import { render, staticRenderFns } from "./CheckboxList.vue?vue&type=template&id=24d5905d&scoped=true&"
import script from "./CheckboxList.vue?vue&type=script&lang=ts&"
export * from "./CheckboxList.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxList.vue?vue&type=style&index=0&id=24d5905d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5905d",
  null
  
)

export default component.exports